import { Fragment, useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
//import "./UserForm.css";
import { useLocation } from "react-router-dom";
import BasicDetailsTab from "./BasicDetailsTab";
import PermissionsTab from "./PermissionTab";

const UserForm = (props: any) => {
  const [activeTab, setActiveTab] = useState("basic");
  const [disabled, setDisabled] = useState(true);
  const location = useLocation();
  const { user_data } = location.state || {};
  const user_id = user_data?.user_id || "";
  const isEdit = Boolean(user_id);
  const renderContent = () => {
    console.log(`active tab: ${activeTab}`);
    switch (activeTab) {
      case "basic":
        return <BasicDetailsTab  setActiveTab={setActiveTab} />;
      case "permissions":
        return <PermissionsTab id={user_id} />;
      default:
        return null;
    }
  };

  useEffect(() => {
    if (props?.page !== undefined) {
      setDisabled(false);
      setActiveTab("permissions");
    } else {
      setActiveTab("basic");
      // Enable permission tab in edit mode
      if (isEdit) {
        setDisabled(false);
      }
    }
  }, [props, isEdit]);
  console.log(disabled, "disabled");

  return (
    <Fragment>
      <div className="page-content px-4 " style={{ marginLeft: "15px" }}>
        {Object.keys(props).length === 0 && (
          <Nav
            variant="tabs"
            activeKey={activeTab}
            onSelect={(selectedKey) => selectedKey && setActiveTab(selectedKey)}
          >
            <Nav.Item>
              <Nav.Link
                eventKey="basic"
                className={`fw-semibold ${
                  activeTab === "basic"
                    ? "text-primary border-bottom border-primary"
                    : "text-muted"
                }`}
              >
                Basic Details
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                 disabled={disabled}
                eventKey="permissions"
                className={`fw-semibold ${
                  activeTab === "permissions"
                    ? "text-primary border-bottom border-primary"
                    : "text-muted"
                }`}
              >
                Permissions
              </Nav.Link>
            </Nav.Item>
          </Nav>
        )}
        {/* Content */}
        <div className="mb-2">{renderContent()}</div>
      </div>
    </Fragment>
  );
};

export default UserForm;


